module.exports = __webpack_public_path__ + "static/cv-mw-8859b4c70122e33c982db0a7a238199a.jpg";